import React, { Component } from 'react';
import { findDOMNode } from 'react-dom';
import styled from 'styled-components';
import { media } from 'lib/style-utils';
import Spinner from 'react-md-spinner';
import { Link } from 'react-router-dom';

import 'index.css';

const Wrapper = styled.div`
  width: 100%;
  height: 100%;
  position: relative;
  transition: all .5s;
`;

const Img = styled.img`
  width: 100%;
  border-radius: 50%;
`;

/** Text Elements */
const Text = styled.div`
  width: 100%;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
  z-index: 5;
`;

const Title = styled.p`
  font-family: Lato;
  font-size: 36px;
  font-weight: bold;
  letter-spacing: 3.6px;
  color: #333333;
  line-height: 1.17;
  z-index:1;

  ${media.w800`
    font-size: 24px;
    letter-spacing: 2.4px;
  `}
`;

const Year = styled.p`
  margin-top: 16px;
  font-family: Lato;
  font-size: 20px;
  font-weight: bold;
  letter-spacing: 3.6px;
  color: #333333;

  ${media.w800`
    margin-top: 20px;
    font-size: 14px;
    letter-spacing: 2.5px;
  `}
`;

const More = styled.button`
  width: 150px;
  height: 45px;
  background: #fff;
  color: #aaaaaa;
  border: 1px solid #eeeeee;
  border-radius: 23px;
  font-family: Lato;
  margin: 36px auto 0;
  font-size: 14px;
  line-height: 1;
  letter-spacing: 0.7px;
  cursor: pointer;
  
  &:hover {
    background: #f9f9f9;
  }

  &:active {
    background: #f2f2f2;
    transform: translateY(1px);
  }

  ${media.mobile`
    margin-top: 20px;
    font-size: 13px;
    letter-spacing: 0.6px;
  `}
`;

const Absolute = styled.div`
  position: absolute;
  transition: all .5s;
`;

const Current1 = Absolute.extend`
  width: 721px;
  top: 0;
  left: 0px;

  ${media.w1440`
    width: 621px;
  `}
  ${media.w1200`
    width: 500px;
    left: 55px;
  `}
  ${media.tablet`
  width: 450px;
  left: 0px;
  `}
  ${media.w800`
  width: 375px;
  left: 0px;
  `}
  ${media.mobile`
    width: 375px;
    left: 0px;
  `}
`;

const Current2 = Absolute.extend`
  width: 719px;
  top: 353px;
  right: 0px;

  ${media.w1440`
    width: 619px;
    top: 353px;
    right: 0px;
  `}
  ${media.w1200`
    width: 500px;
    top: 370px;
    right: 131px;
  `}
  ${media.tablet`
    width: 400px;
    top: 718px;
    right: 295px;
  `}
  ${media.w800`
    width: 375px;
    top: 669px;
    right: 141px;
  `}
  ${media.mobile`
    top: 845px;
    right: 0;
  `}
`;

const Circle1 = Absolute.extend`
  content: "";
  width: 323px;
  height: 323px;
  top: 74px;
  right: 410px;
  border-radius: 50%;
  background-color: ${props => props.color === '#988ff1' ? '#2bd571' : '#988ff1'};
  z-index: 1;
  
  ${media.w1440`
    width: 263px;
    height: 263px;
    top: 113px;
    right: 320px;
  `}
  ${media.w1200`
    width: 171px;
    height: 171px;
    top: 501px;
    right: 631px;
  `}
  ${media.tablet`
    width: 271px;
    height: 271px;
    top: 451px;
    right: 412px;
  `}
  ${media.w800`
    width: 168px;
    height: 168px;
    top: 376px;
    right: 327px;
  `}
  ${media.mobile`
    top: 355px;
    right: 207px;
  `}
`;
  
  const Circle2 = Absolute.extend`
    content: "";
    width: 108px;
    height: 108px;
    top: 380px;
    right: 0px;
    border-radius: 50%;
    background-color: ${props => props.color === '#ffa0ab' ? '#2bd571' : '#ffa0ab'};
    z-index: 1;
    
    ${media.w1440`
      width: 88px;
      height: 88px;
      top: 384px;
      right: 0px;
    `}
    ${media.w1200`
      width: 240px;
      height: 240px;
      top: 131px;
      right: 228px;
    `}
    ${media.tablet`
      width: 137px;
      height: 137px;
      top: 328px;
      right: 266px;
    `}
    ${media.w800`
      width: 94px;
      height: 94px;
      top: 1024px;
      right: 377px; 
    `}
    ${media.mobile`
      top: 1174px;
      right: 281px;
    `}
  `;
  
  const Circle3 = Absolute.extend`
    content: "";
    width: 232px;
    height: 232px;
    top: 1019px;
    right: 464px;
    border-radius: 50%;
    background-color: ${props => props.color === '#ffdf45' ? '#2bd571' : '#ffdf45'};
    z-index: 1;

    ${media.w1440`
      width: 162px;
      height: 162px;
      top: 897px;
      right: 461px;
    `}
    ${media.w1200`
      width: 232px;
      height: 232px;
      top: 863px;
      right: 334px;
    `}
    ${media.tablet`
      top: 820px;
      right: 64px;
    `}
    ${media.w800`
      width: 149px;
      height: 149px;
      top: 969px;
      right: 71px;
    `}
    ${media.mobile`
      top: 1194px;
      right: 0px;
    `}
`;

const GoShop = Absolute.extend`
  width: 544px;
  height: 544px;
  top: 706px;
  left: 234px;
  background: ${props => props.color === '#ef4b30' ? '#6da1fa' : '#ef4b30'};
  border-radius: 50%;

  ${media.w1440`
    width: 444px;
    height: 444px;
    top: 617px;
    left: 166px;
  `}
  ${media.w1200`
    width: 430px;
    height: 430px;
    top: 667px;
    left: 42px;
  `}
  ${media.tablet`
    width: 380px;
    height: 380px;
    top: 443px;
    left: 383px;
  `}
  ${media.w800`
    width: 350px;
    height: 350px;
    top: 357px;
    left: 261px;
  `}
  ${media.mobile`
    top: 495px;
    left: 25px;
  `}
`;

class Season extends Component {

  shouldComponentUpdate(nextProps, nextState) {
    return this.props !== nextProps;
  }

  componentDidMount() {
    window.scrollTo(0,0);
    const { handleShake } = this;
    const circle1 = findDOMNode(this.circle1);
    const circle2 = findDOMNode(this.circle2);
    const circle3 = findDOMNode(this.circle3);
    const targets = [circle1, circle2, circle3];

    targets.forEach((target) => {
      handleShake(target, 'add');
    });
  }

  componentWillUnmount() {
    const { handleShake } = this;
    const circle1 = findDOMNode(this.circle1);
    const circle2 = findDOMNode(this.circle2);
    const circle3 = findDOMNode(this.circle3);
    const targets = [circle1, circle2, circle3];

    targets.forEach((target) => {
      handleShake(target, 'remove');
    });
  }
  
  handleShake = (elements, add) => {
    const { shakeHandler } = this;

    if (add === 'add') {
      elements.addEventListener('click', shakeHandler);
    } else {
      elements.removeEventListener('click', shakeHandler);
    }
}

  shakeHandler = (event) => {
    event.target.classList.add('shake');
    
    setTimeout(() => {
      event.target.classList.remove('shake');
    }, 1500);
  }

  handleSetGalleryIndex = (e) => {
    const { UIActions } = this.props;
    const index = e.target.getAttribute('data-index');

    if (index !== undefined && UIActions !== undefined) {
      UIActions.setGallery({index});
    } 
  }

  render() {
    const { color, data } = this.props;
    const { handleSetGalleryIndex } = this;

    return (
      <Wrapper>
        <Current1>
          {
            !data[0] ? 
              <Spinner
                size="60px"
                style={{
                  position: 'absolute',
                  top: '50%',
                  left: '50%'
                }}
              /> : (
              <div>
                <Img src={data[0] && data[0].thumbnail.url}/>
                <Text>
                  <Title>{data[0] && data[0].seasonText}</Title>
                  <Year>{data[0] && data[0].yearText}</Year>
                  <Link to="/lookbook/0"><More data-index={0} onClick={handleSetGalleryIndex}>VIEW MORE</More></Link>
                </Text>
              </div>
            )
          }
        </Current1>

        <Current2>
          {
            !data[1] ? 
              <Spinner
                size="60px"
                style={{
                  position: 'absolute',
                  top: '50%',
                  left: '50%'
                }}
              /> : (
              <div>
                <Img src={data[1] && data[1].thumbnail.url}/>
                <Text>
                  <Title>{data[1] && data[1].seasonText}</Title>
                  <Year>{data[1] && data[1].yearText}</Year>
                  <Link to="/lookbook/1"><More data-index={1} onClick={handleSetGalleryIndex}>VIEW MORE</More></Link>
                </Text>
              </div>
            )
          }
        </Current2>

        <Circle1 color={color} innerRef={ref => this.circle1 = ref}/>
        <Circle2 color={color} innerRef={ref => this.circle2 = ref}/>
        <Circle3 color={color} innerRef={ref => this.circle3 = ref}/>

        <GoShop color={color}>
          <Text>
            <Title style={{color: '#ffffff'}}>BABY DEEDEE</Title>
            <Year style={{color: '#ffffff'}}>GO TO ONLINE SHOP</Year>
            <a href="http://www.gurmbyh.com/product/list.html?cate_no=115" target="_blank" rel="noopener noreferrer"><More>SHOP NOW</More></a>
          </Text>
        </GoShop>
      </Wrapper>
    );
  };
}

export default Season;



// WEBPACK FOOTER //
// ./src/components/Lookbook/Season.js